import showNotification from "./showNotification";

const handleCopy = (text, message = "Código copiado al portapapeles") => {
    navigator.clipboard.writeText(text);
    showNotification({
        color: "green",
        status: "success",
        title: "Copiado",
        message,
        autoClose: 2000,
    });
}

export { handleCopy };